<template>
    <div
        :data-component="$options.name"
        class="flex"
    >
        <cs-secondary-button
            v-if="contact.displayCallOption"
            :class="{
                'mr-16': position !== ContactBtnPosition.CONTACT_INFO_TOP,
                'w-1/2':
                    (position === ContactBtnPosition.CONTACT_INFO_BOTTOM ||
                        (position === ContactBtnPosition.STICKY_BAR && stickyBarBottom)) &&
                    contact.displayCallOption,
            }"
            :href="shouldHaveCallModalButton() ? '' : getSinglePhoneNumber()"
            :isSmall="position === ContactBtnPosition.STICKY_BAR"
            :isCentered="true"
            @click="shouldHaveCallModalButton() ? openCallModal() : trackPhoneNumberClick()"
            >Anrufen</cs-secondary-button
        >
        <cs-primary-button
            :class="{
                'mb-8': position === ContactBtnPosition.CONTACT_INFO_TOP && contact.displayCallOption,
                'w-1/2':
                    (position === ContactBtnPosition.CONTACT_INFO_BOTTOM ||
                        (position === ContactBtnPosition.STICKY_BAR && stickyBarBottom)) &&
                    contact.displayCallOption,
                'w-full':
                    (position === ContactBtnPosition.CONTACT_INFO_BOTTOM ||
                        position === ContactBtnPosition.STICKY_BAR) &&
                    !contact.displayCallOption,
            }"
            :isSmall="position === ContactBtnPosition.STICKY_BAR"
            :isCentered="true"
            @click="openContactModal"
            >Nachricht</cs-primary-button
        >
        <ms-detail-modal-contact
            :isVisible="contactModalIsVisible"
            :componentId="componentId"
            @closeModal="closeContactModal"
        />
        <ms-detail-modal-call
            :isVisible="callModalIsVisible"
            :contact="contact"
            :exposeeId="exposeeId"
            @closeModal="closeCallModal"
        />
    </div>
</template>
<script lang="ts" src="./MsDetailContactBtnGroup.ts" />
